export default {"src":"/_next/static/media/spares.b1a21d3b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};